import React from "react";
import { Button } from "reactstrap";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  padding: 1rem;
`;

const StyledButton = styled(Button)`
  max-width: 300px;
  width: 100%;
  align-self: center;
`;

const BorderImg = styled.img`
  width: 95%;
  margin-left: auto;
  margin-right: auto;
`;

export default function Support() {
  return (
    <Container>
      <BorderImg src="horizontal-border-1.png" alt="This is a border." />
      <p className="tac  mb1">
        The Lubber Fiend is a DIY music and events space in Newcastle upon Tyne,
        opened in May 2022.
      </p>
      <p className="tac  mb1">
        We are a <a href="/events">DIY music space</a>, a bar, a radio studio{" "}
        <a href="/radio">Slack's</a> and we now incorporate a beautiful
        restaurant: <a href="/kitchen">Lubber Kitchen</a>.
      </p>
      <p className="tac  mb1">
        We have a hugely diverse programme, including gigs of all genres, club
        nights, film screenings, Ceilidh's, markets and lots more.
      </p>
      <p className="tac  mb1">
        Times are increasingly tough for DIY venues, with ever-rising operating
        costs, and no core funding or sponsorship. So if you value what the
        Lubber Fiend has brought to the city, and our programme, the best way to
        support us is to become a Member of the venue.
      </p>
      <StyledButton
        className="mb1"
        color="success"
        href="https://app.joinit.com/o/the-lubber-fiend-cic/"
        tag="a"
      >
        BECOME A MEMBER
      </StyledButton>
      <p className="tac  mb1">
        We offer a range of Tiers with various benefits for Members and Patrons
        alike, including discounts on food and drink, early bird tickets,
        free-to-members events, exclusive merch - all the way up to free entry
        to our events for a lifetime.
      </p>
      <p className="tac  mb1">
        We are hugely grateful to all of our Members - thank you for helping to
        keep the lights on and for continuing to allow us to provide a space for
        all of the weird bands, DJs and events that roll through town.
      </p>
      <p className="tac  mb1">
        You can also still donate, if you prefer, via the same link.
      </p>
      <StyledButton
        className="mb1"
        color="success"
        href="https://app.joinit.com/o/the-lubber-fiend-cic/"
        tag="a"
      >
        MAKE A DONATION
      </StyledButton>
      <p className="tac  mb1">
        You can also gift a membership to someone here:
      </p>
      <StyledButton
        className="mb1"
        color="success"
        href="https://app.joinit.com/o/the-lubber-fiend-cic/gifts"
        tag="a"
      >
        GIFT A MEMBERSHIP
      </StyledButton>
      <BorderImg
        className="mb1"
        style={{
          filter: "invert(100%)",
          "-webkit-transform": "scaleX(-1)",
          transform: "scaleX(-1)",
        }}
        src="horizontal-border-1.png"
        alt="This is a border."
      />
    </Container>
  );
}
